import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const MarkerSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <g filter="url(#filter0_d_2472_174276)">
        <path
          d="M56.8507 29.6845C56.8507 45.4807 39.9161 63.2317 33.9254 71C27.9082 63.6612 11 46.4828 11 29.6845C11 17.1562 21.264 7 33.9254 7C46.5867 7 56.8507 17.1562 56.8507 29.6845Z"
          fill="white"
        />
      </g>
      <path
        d="M36.7451 40.9177H30.9281V33.3227C30.9281 32.8152 31.2649 32.4985 31.7579 32.4985H35.9254C36.4284 32.4985 36.7451 32.8152 36.7451 33.3227V40.9177ZM23.9092 40.1288C23.9092 41.6391 24.8205 42.5304 26.3508 42.5304H41.3605C42.8908 42.5304 43.8021 41.6391 43.8021 40.1288V30.7487L34.5434 22.9878C34.0966 22.598 33.5912 22.6125 33.1589 22.9878L23.9092 30.7397V40.1288ZM20.5083 29.8894C20.5083 30.3003 20.8347 30.6868 21.3748 30.6868C21.6521 30.6868 21.8758 30.5376 22.0785 30.3694L33.4266 20.8362C33.7003 20.6061 34.004 20.5981 34.2847 20.8362L45.6148 30.3694C45.8275 30.5376 46.0512 30.6868 46.3285 30.6868C46.803 30.6868 47.175 30.3905 47.175 29.9194C47.175 29.6131 47.0814 29.4104 46.8551 29.2232L35.157 19.3821C34.3518 18.6995 33.3785 18.6995 32.5642 19.3821L20.8381 29.2232C20.6119 29.4104 20.5083 29.6532 20.5083 29.8894ZM41.1535 25.0735L43.8021 27.3052V22.0592C43.8021 21.6067 43.4978 21.317 43.0553 21.317H41.9158C41.4678 21.317 41.1535 21.6067 41.1535 22.0592V25.0735Z"
        fill={color}
      />
      <defs>
        <filter
          id="filter0_d_2472_174276"
          x="0.529429"
          y="0.717658"
          width="66.7917"
          height="84.9411"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.18823" />
          <feGaussianBlur stdDeviation="5.23529" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2472_174276"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2472_174276"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export { MarkerSvg };
